import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const ABTesting00Table: GenericTableSchemaInterface = {
  id: "abtesting-00",
  name: "AB Testing 00",
  description: "This table assists in running AB tests.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "ExperimentName"
    },
    c04: {
      name: "Role (control or experiment)"
    },
    c05: {
      name: "IsLocationSetToStart (boolean)"
    },
    c06: {
      name: "ZIP Code Provided"
    },
    c07: {
      name: "Location Selected"
    },
    c08: {
      name: "Channel",
      variable: VarKey.UserChannel
    }
  }
};
